export { default } from './Pendo'
